module.exports = __webpack_public_path__ + "static/Gilroy-SemiBold-a5cf732b15078843b237bd58f3ed44cd.ttf";